import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import Table from '../../../common/Table';
import { bankReconciliationManualVoucherPaymentColumns } from '../../../../config/columns';
import {
  getBankReconciliationManualVoucherPayments,
  clearBankReconciliationManualVoucherPayments,
} from '../../../../actions';

const BankReconciliationManualVoucherPaymentsTable = ({
  manualVoucherId,
  documentName,
  corporate,
  payments,
  loading,
  dispatchGetBankReconciliationManualVoucherPayments,
  dispatchClearBankReconciliationManualVoucherPayments,
}) => {
  useEffect(() => {
    dispatchGetBankReconciliationManualVoucherPayments({ manualVoucherId });

    return () =>
      dispatchClearBankReconciliationManualVoucherPayments({ manualVoucherId });
  }, [manualVoucherId]);

  const data = useMemo(() => payments.toJS(), [payments]);

  return (
    <div className="p-3 pl-5 bg-light">
      <h6 className="text-muted">Pagos del comprobante {documentName}</h6>
      <Table
        columns={bankReconciliationManualVoucherPaymentColumns({
          manualVoucherId,
          corporate,
        })}
        data={data}
        loading={loading}
        manual={false}
        showPagination={false}
        pageSize={data.length || 1}
        groupedColumns
      />
    </div>
  );
};

BankReconciliationManualVoucherPaymentsTable.propTypes = {
  manualVoucherId: PropTypes.number.isRequired,
  documentName: PropTypes.string.isRequired,
  corporate: PropTypes.shape({
    date: PropTypes.string.isRequired,
    holderType: PropTypes.string.isRequired,
    corporateId: PropTypes.number.isRequired,
    currency: PropTypes.string,
  }).isRequired,
  payments: PropTypes.instanceOf(Immutable.List).isRequired,
  loading: PropTypes.bool,
  dispatchGetBankReconciliationManualVoucherPayments: PropTypes.func.isRequired,
  dispatchClearBankReconciliationManualVoucherPayments:
    PropTypes.func.isRequired,
};

BankReconciliationManualVoucherPaymentsTable.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ SalesUnit }, { manualVoucherId }) => ({
  payments:
    SalesUnit.BankReconciliation.getIn([
      'paymentsByManualVoucher',
      manualVoucherId,
      'content',
    ]) || Immutable.List(),
  loading:
    SalesUnit.BankReconciliation.getIn([
      'paymentsByManualVoucher',
      manualVoucherId,
      'loading',
    ]) || false,
});

const mapDispatchToProps = {
  dispatchGetBankReconciliationManualVoucherPayments:
    getBankReconciliationManualVoucherPayments,
  dispatchClearBankReconciliationManualVoucherPayments:
    clearBankReconciliationManualVoucherPayments,
};

export { BankReconciliationManualVoucherPaymentsTable };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BankReconciliationManualVoucherPaymentsTable);
